module.exports = "<p>\n  links-page works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/links-page/links-page.component.html
// module id = 427
// module chunks = 0